import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    target: {
      borderTop: 'solid #ccc 1px',
      borderBottom: 'solid #ccc 1px',
      marginBottom: theme.spacing(1),
      breakInside: 'avoid',
      pageBreakInside: 'avoid',
    },
    rentTarget: {
      borderTop: 'solid #ccc 3px',
      borderBottom: 'solid #ccc 3px',
    },
    icon: {
      fontSize: '50px',
      textAlign: 'center',
      paddingRight: theme.spacing(2),
      '& svg': {
        position: 'relative',
        top: theme.spacing(1),
      },
    },
    grade: {
      '& svg': { verticalAlign: 'middle', marginRight: theme.spacing(1) },
      '&.grade_NONE': { color: theme.palette.grey['600'] },
      '&.grade_PARTIAL': { color: theme.palette.grey['900'] },
      '&.grade_FULL': { color: theme.palette.common.black },
      '&.grade_IN_PROCESS': { color: theme.palette.common.black },
    },
    chart: {
      marginTop: -theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    valuation: {
      paddingBottom: theme.spacing(1),
    }
  }),
);

export default useStyles;
